// extracted by mini-css-extract-plugin
var _1 = "ra-section";
var _2 = "ra-section-color-black";
var _3 = "ra-section-color-gray";
var _4 = "ra-section-color-white";
var _5 = "ra-section-padding-bottom";
var _6 = "ra-section-padding-none";
var _7 = "ra-section-padding-top";
var _8 = "ra-section-vertical-margin";
export { _1 as "sectionCls", _2 as "sectionColorBlackCls", _3 as "sectionColorGrayCls", _4 as "sectionColorWhiteCls", _5 as "sectionPaddingBottomCls", _6 as "sectionPaddingNoneCls", _7 as "sectionPaddingTopCls", _8 as "sectionVerticalMarginCls" }
